import React from "react";

import styles from "../../assets/styles/contactCard.module.scss";

import facebook from "../../assets/images/facebook-circle.svg";
import phone from "../../assets/images/phone.svg";
import mobile from "../../assets/images/mobile.svg";
import address from "../../assets/images/address.svg";
import mail from "../../assets/images/email-simple.svg";

interface IContactCardCityProps{
    addressAlt: string,
    phoneAlt: string,
    iframeMinHeight: string
}

interface IContactCardProps{
    city: string,
    clinic: string,
    address: string,
    addressAlt: string,
    location: string,
    locationGoogleMaps: string,
    postalCode: string,
    phoneAlt: string,
    phoneOption1: string,
    phoneOption2: string,
    phoneOption3: string,
    facebook: string,
    iframeMinHeight: string
}

interface IPhoneProps{
    phone: string,
    phoneAlt: string,
    img: string
}

function Phone(props: IPhoneProps){
    return <a 
        className={`${styles.notALink} d-flex flex-row align-items-center justify-content-center gap-2 h5`}
        href={`tel:+351${props.phone}`}>
            <img height={15} src={props.img} alt={props.phoneAlt} />
            {props.phone}
    </a>;
}

function ContactCard(props: IContactCardProps){
    return (
      <div className={`${styles.contactCard} card py-4`}>
        <div className="card-body text-center">
          <h4 className={`text-uppercase m-0 ${styles.city}`}>{props.city}</h4>
          <h6 className={`text-uppercase m-0 ${styles.clinic}`}>{props.clinic}</h6>
  
          <hr className="my-4 mx-auto" />
  
          <div className="d-flex row gap-4 justify-content-center">
            <div className="d-flex col-12 flex-column small text-black-50 gap-3 align-items-center">
                <Phone img={phone} phone={props.phoneOption1} phoneAlt={props.phoneAlt} />
                <Phone img={mobile} phone={props.phoneOption2} phoneAlt={props.phoneAlt} />
                <Phone img={mobile} phone={props.phoneOption3} phoneAlt={props.phoneAlt} />
            </div>
            <div className="d-flex col-12 flex-column gap-2 justify-content-center align-items-center">
              <div className={`${styles.iframeContainer} mb-3`}>
                <iframe style={{minHeight: props.iframeMinHeight}} title="Iframe Google Maps" src={props.locationGoogleMaps}></iframe>
              </div>
              <div className="d-flex col-12 flex-row small text-black-50 gap-2 justify-content-center align-items-center mb-3">
                <img className="w-auto" height={20} src={address} alt={props.addressAlt} />
                <a className={styles.notALink} href={props.location}>{props.address}, {props.postalCode}</a>
              </div>
                <a className={`d-flex gap-2 ${styles.notALink}`} href="mailto:clinicadentariamarini@gmail.com">
                <img height={20} src={mail} alt="E-mail" />clinicadentariamarini@gmail.com</a>
            </div>
            <div className="d-flex col-12 small text-black-50 gap-3 justify-content-center align-items-center">
              <a className={`d-flex gap-2 ${styles.notALink}`} href={`https://www.facebook.com/${props.facebook}`}>
                <img height={20} src={facebook} alt="Facebook" /></a>
            </div>
          </div>        
        </div>
      </div>
    );
  }

  export function ContactCardPorto(props: IContactCardCityProps){
    return <ContactCard 
                city="Porto" 
                clinic="Marini Medicina Dentária"
                address="Rua da Constituição 402"
                postalCode="4200-192 Porto"
                //location="https://maps.app.goo.gl/aVHrR4L8UN539Qac8"
                location="geo:41.16276010798559,-8.602936"
                locationGoogleMaps="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3003.7497651772474!2d-8.605124984334532!3d41.16181131791117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2464585035d3b7%3A0x2493c3b88813de96!2sMarini+Medicina+Dent%C3%A1ria!5e0!3m2!1sen!2spt!4v1552604503755"
                iframeMinHeight={props.iframeMinHeight}
                addressAlt={props.addressAlt}
                phoneAlt={props.phoneAlt}
                phoneOption1="225505043"
                phoneOption2="962693181"
                phoneOption3="912639181"
                facebook="clinicamariniporto" />;   
  }

  export function ContactCardApulia(props: IContactCardCityProps){
    return <ContactCard 
                city="Apúlia" 
                clinic="Clínica de Medicina Dentária Apúlia"
                address="Rua da Casa do Povo 32"
                postalCode="4740-079 Apúlia"
                //location="https://maps.app.goo.gl/HE8UiCFSdme3K2uj7"
                location="geo:41.48545854106407,-8.770173984074203"
                locationGoogleMaps="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2988.883925964934!2d-8.771976384327244!3d41.48511609789343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd24491557e36541%3A0x85a44ff1bd6659d6!2sPedro+Marini+Cl.+Med+Dent%C3%A1ria!5e0!3m2!1sen!2spt!4v1552604766160"
                iframeMinHeight={props.iframeMinHeight}
                addressAlt={props.addressAlt}
                phoneAlt={props.phoneAlt}
                phoneOption1="253982282"
                phoneOption2="915108369"
                phoneOption3="925319696"
                facebook="clinicadentariaapulia" />
  }